@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full mb-3">
      <div class="mb-2">
        <div class="leading-6 font-medium">{{ field.label | localize }}@if (field.required) {
          <span> *</span>
        }</div>
        @if (field.hint) {
          <div class="text-md text-secondary">{{ field.hint | localize }}</div>
        }
      </div>
      <!-- Aqui ira el contenedor del fichero -->
      <file-uploader-component [acceptedExtensions]="field.extensions" [control]="field.control" [filePattern]="null"
      [embedded]="field.embedded"></file-uploader-component>
      @if (!field.readonly && !field.control.disabled && field.control.touched && field.control.errors) {
        @if (field.control.errors.required) {
          <div class="text-sm text-warn leading-none font-medium mt-2">
            {{ 'errorRequiredField' | transloco }}
          </div>
        }
      }
    </div>
  }
} @else {
  {{ displayedValue }}
}
